exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".note-view{color:#87a6bc;font-family:Merriweather,Georgia,Times New Roman,Times,serif;font-size:14px}.note-view .subject:not(.excerpt){color:#2e4453;font-weight:700}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./~/autoprefixer-loader!./src/note-view.scss
 ** module id = 391
 ** module chunks = 0
 **/